/**
 * Buddy Points Widget Fix
 * - Moves widget to flush bottom-right corner (desktop & mobile)
 * - Fixes logo overlapping the text
 * - Renames "Buddy Points" to "Rewards"
 */
(function() {
  function fixWidget() {
    var widget = document.querySelector('one-loyalty-widget');
    if (!widget || !widget.shadowRoot) return false;

    var wrapper = widget.shadowRoot.querySelector('.one-loyalty__popup-widget');
    if (!wrapper) return false;

    // Fix positioning - flush to bottom right
    wrapper.style.setProperty('bottom', '10px', 'important');
    wrapper.style.setProperty('right', '10px', 'important');

    // Rename "Buddy Points" to "Rewards"
    var titleEl = widget.shadowRoot.querySelector('._title_1b5fz_67');
    if (titleEl && titleEl.textContent.trim() !== 'Rewards') {
      titleEl.textContent = 'Rewards';
    }

    // Fix logo overlap - inject a style tag into the shadow DOM
    var existingFix = widget.shadowRoot.querySelector('#buddy-points-fix-style');
    if (!existingFix) {
      var style = document.createElement('style');
      style.id = 'buddy-points-fix-style';
      style.textContent = [
        /* Ensure the button layout has proper gap between icon and text */
        '._button-widget_1b5fz_6 { gap: 8px !important; align-items: center !important; }',
        '._icon_1b5fz_33 { flex-shrink: 0 !important; width: 32px !important; height: 32px !important; }',
        '._icon_1b5fz_33 img { width: 32px !important; height: 32px !important; object-fit: contain !important; }',
        '._title_1b5fz_67 { flex-shrink: 0 !important; white-space: nowrap !important; overflow: visible !important; }',
        /* Mobile adjustments */
        '@media (max-width: 749px) {',
        '  .one-loyalty__popup-widget { bottom: 10px !important; right: 10px !important; }',
        '}'
      ].join('\n');
      widget.shadowRoot.appendChild(style);
    }

    return true;
  }

  // Try immediately, then retry with intervals as the widget loads asynchronously
  if (!fixWidget()) {
    var attempts = 0;
    var interval = setInterval(function() {
      attempts++;
      if (fixWidget() || attempts > 30) {
        clearInterval(interval);
      }
    }, 500);
  }

  // Also fix on page navigation (SPA-style)
  var observer = new MutationObserver(function() {
    fixWidget();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
